import { AppAction } from '../../../../state/app';
import { SampleDevelopmentTlApprovalRequest } from '../../../../state/sampleDevelopmentTlApprovalRequest/sampleDevelopmentTlApprovalRequest.types';
import { FAILURE, REQUEST, SUCCESS } from '../../../../utils/actionTypeUtil';
import { FETCH_PENDING_APPROVAL_SAMPLE_DEV_TL_LIST } from './pendingApprovalSampleDevTlRequestList.actions';

export interface PendingApprovalSampleDevTlRequestListState {
  loading: boolean;
  items: ReadonlyArray<SampleDevelopmentTlApprovalRequest>;
  errorMessage: string;
  totalItems: number;
}

const initialState: PendingApprovalSampleDevTlRequestListState = {
  errorMessage: '',
  items: [],
  loading: false,
  totalItems: 0,
};

export default (
  state: PendingApprovalSampleDevTlRequestListState = initialState,
  action: AppAction,
): PendingApprovalSampleDevTlRequestListState => {
  switch (action.type) {
    case REQUEST(FETCH_PENDING_APPROVAL_SAMPLE_DEV_TL_LIST):
      return { ...state, loading: true };
    case SUCCESS(FETCH_PENDING_APPROVAL_SAMPLE_DEV_TL_LIST):
      return {
        ...state,
        items: action.payload.data,
        loading: false,
        totalItems: +action.payload.headers['x-total-count'],
      };
    case FAILURE(FETCH_PENDING_APPROVAL_SAMPLE_DEV_TL_LIST):
      return { ...state, loading: false, errorMessage: action.payload.errorMessage };
    default:
      return state;
  }
};
